module.exports = __webpack_public_path__ + "9487023fd5f42d4145e4cd77173eef46.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/studio9.jpg
// module id = 186
// module chunks = 0